import { render, staticRenderFns } from "./user-email-edit-box.vue?vue&type=template&id=0248f394&"
import script from "./user-email-edit-box.vue?vue&type=script&lang=js&"
export * from "./user-email-edit-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports